<main class="users-page">
  <h1>Administrer brugere</h1>
  <p>Tildel SAM-roller til registrerede brugere. Agillic-brugere med en tilknyttet butik får automatisk adgang til den butik.</p>
  <mat-form-field appearance="outline" class="search">
    <mat-label>Søg efter navn, bruger-id eller rolle</mat-label>
    <input matInput [(ngModel)]="query" autocomplete="off">
  </mat-form-field>
  <button mat-button [disabled]="loading" (click)="load()">Opdater brugerlisten</button>

  @if (loading) { <p role="status">Henter brugere…</p> }
  @else if (error) {
    <div class="error" role="alert">{{ error }} <button mat-button (click)="load()">Prøv igen</button></div>
  } @else if (!users.length) { <p>Der er endnu ingen brugere at vise.</p> }
  @else if (!filteredUsers.length) { <p>Ingen brugere matcher søgningen.</p> }
  @else {
    <table mat-table [dataSource]="filteredUsers" class="mat-elevation-z1">
      <ng-container matColumnDef="displayName"><th mat-header-cell *matHeaderCellDef>Navn</th><td mat-cell *matCellDef="let user">{{ user.displayName || '—' }}</td></ng-container>
      <ng-container matColumnDef="userId"><th mat-header-cell *matHeaderCellDef>Bruger-id</th><td mat-cell *matCellDef="let user">{{ user.userId }} <small>({{ user.userType }})</small></td></ng-container>
      <ng-container matColumnDef="roles"><th mat-header-cell *matHeaderCellDef>Administration og øvrige tildelinger</th><td mat-cell *matCellDef="let user"><strong>{{ user.roles.length ? user.roles.join(', ') : 'Ingen applikationsroller' }}</strong>@if (assignmentLabel(user)) {<span class="other-assignments">{{ assignmentLabel(user) }}</span>}</td></ng-container>
      <ng-container matColumnDef="actions"><th mat-header-cell *matHeaderCellDef></th><td mat-cell *matCellDef="let user"><button mat-button color="primary" (click)="edit(user)">Rediger</button></td></ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr><tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</main>
